import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

export class UpdateUserAction {
  static readonly type = '[User] Update User State';
  constructor(public userName: string, public firstName: string, public lastName: string) {}
}

export class ResetUserStateAction {
  static readonly type = '[User] Reset User State';
}

export interface UserStateModel {
  loggedIn: boolean;
  userName: string;
  firstName: string;
  lastName: string;
}

const defaultState: UserStateModel = {
  loggedIn: false,
  userName: '' as string,
  firstName: '' as string,
  lastName: '' as string
};

@State<UserStateModel>({
  name: 'user',
  defaults: defaultState
})
@Injectable()
export class UserState {
  @Selector()
  static getUser(state: UserStateModel) {
    return state;
  }

  @Selector()
  static getLoggedIn(state: UserStateModel) {
    return state.loggedIn;
  }

  @Selector()
  static getUserName(state: UserStateModel) {
    return state.userName;
  }

  @Selector()
  static getFirstName(state: UserStateModel) {
    return state.firstName;
  }

  @Selector()
  static getLastName(state: UserStateModel) {
    return state.lastName;
  }

  @Action(UpdateUserAction)
  updateUser({ patchState }: StateContext<UserStateModel>, { userName, firstName, lastName }: UpdateUserAction) {
    patchState({ loggedIn: true, userName, firstName, lastName });
  }

  @Action(ResetUserStateAction)
  resetUserState({ setState }: StateContext<UserStateModel>) {
    setState(defaultState);
  }
}
